export const tabList:{
  key: string;
  text: string;
}[] = [
  {
    key: 'technology',
    text: 'technology'
  },
  {
    key: 'media',
    text: 'media'
  },
  {
    key: 'services',
    text: 'services'
  }
];

export const menuList:{
  text: string;
  href: string;
  top?: number;
}[] = [
  {
    text: 'About Us',
    href: 'navbar',
  },
  {
    text: 'The Cugate Music Catalogue',
    href: 'the-cugate-music-catalogue'
  },
  {
    text: 'Watermark & Footprint',
    href: 'watermark-footprint'
  },
  {
    text: 'Stakeholders',
    href: 'stakeholders'
  },
  {
    text: 'Products & Services',
    href: 'products-services'
  },
  {
    text: 'Contacts',
    href: 'we-are-global'
  }
];

export const featureList:{
  text: string;
  img_index: number;
}[] = [
  {
    text: 'Content',
    img_index: 18
  },
  {
    text: 'Publishing',
    img_index: 19
  },
  {
    text: 'Rights Management through Blockchain',
    img_index: 20
  },
  {
    text: 'Digital Distribution',
    img_index: 21
  },
  {
    text: 'Radio Monitoring',
    img_index: 22
  },
  {
    text: 'Data Analysis',
    img_index: 23
  },
  {
    text: 'Physical Distribution',
    img_index: 24
  },
  {
    text: 'Snyc Licensing',
    img_index: 25
  },
  {
    text: 'Accounting',
    img_index: 26
  }
];

export const officeList:{
  text: string;
  gmail: string;
  coords: string;
}[] = [
  {
    text: 'Germany',
    gmail: 'berlin@cugate.com',
    coords: '286,472,531,504',
  },
  {
    text: 'Mexico',
    gmail: 'veracruz@cugate.com',
    coords: '261,525,539,548',
  },
  {
    text: 'Great Britain',
    gmail: 'london@cugate.com',
    coords: '197,568,455,599',
  },
  {
    text: 'USA',
    gmail: 'newyorkcity@cugate.com',
    coords: '210,619,533,644',
  },
  {
    text: 'Cuba',
    gmail: 'habana@cugate.com',
    coords: '232,666,499,694',
  },
  {
    text: 'Georgia',
    gmail: 'tblisi@cugate.com',
    coords: '1044,481,1274,510',
  },
  {
    text: 'Russia',
    gmail: 'petersburg@cugate.com',
    coords: '1021,531,1332,556',
  },
  {
    text: 'China',
    gmail: 'shenzhen@cugate.com',
    coords: '1010,579,1298,604',
  },
  {
    text: 'Taiwan',
    gmail: 'taipei@cugate.com"',
    coords: '1033,625,1276,655',
  }
];